// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.User = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.User = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var User = _exports.User = function User(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.83316 13.6172C6.16508 13.6172 4.78416 14.9331 4.78416 16.6662C4.78416 17.0073 4.50762 17.2838 4.16649 17.2838C3.82537 17.2838 3.54883 17.0073 3.54883 16.6662C3.54883 14.2326 5.50124 12.3818 7.83316 12.3818H12.0832C14.5168 12.3818 16.3675 14.3342 16.3675 16.6662C16.3675 17.0073 16.091 17.2838 15.7498 17.2838C15.4087 17.2838 15.1322 17.0073 15.1322 16.6662C15.1322 14.9981 13.8162 13.6172 12.0832 13.6172H7.83316Z",
      fill: "#323232"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0651 4.78116C10.889 3.68082 9.1024 3.68298 7.92869 4.78764C6.79848 5.85137 6.82425 7.70226 7.95546 8.90417C9.01918 10.0344 10.8701 10.0086 12.072 8.87739C13.2166 7.80009 13.2386 5.96168 12.0651 4.78116ZM12.9263 3.8751C11.2689 2.31756 8.72849 2.31833 7.07198 3.87739C5.36885 5.48034 5.50975 8.12945 7.04521 9.76087C8.64815 11.464 11.2973 11.3231 12.9287 9.78764C14.6144 8.20105 14.5954 5.5461 12.9446 3.89286C12.9416 3.88986 12.9386 3.88689 12.9355 3.88393C12.9325 3.88095 12.9294 3.87801 12.9263 3.8751Z",
      fill: "#323232"
    }));
  };
});
